module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticStyle: {
      "padding-top": ".2rem"
    }
  }), _vm._v(" "), _vm._l((_vm.list), function(item, k) {
    return _c('div', {
      key: k
    }, [_c('van-divider', [_vm._v(_vm._s(item.name))]), _vm._v(" "), (item.list.length) ? _c('div', _vm._l((item.list), function(row, i) {
      return _c('van-cell-group', {
        key: i
      }, [(item.name == '业余等级') ? _c('div', [_c('div', {
        staticClass: "cert-li"
      }, [(row.cert_back_url) ? _c('img', {
        attrs: {
          "src": row.cert_back_url,
          "alt": ""
        }
      }) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "cert-button"
      }, [(!_vm.isApp) ? _c('van-button', {
        staticStyle: {
          "margin": "10px auto",
          "text-align": "center"
        },
        attrs: {
          "type": "default",
          "round": ""
        },
        on: {
          "click": function($event) {
            return _vm.download(row.name + '-' + row.grade, row.pdf_url)
          }
        }
      }, [_vm._v("请点击按钮下载\n                ")]) : _c('van-button', {
        staticStyle: {
          "margin": "10px auto",
          "text-align": "center"
        },
        attrs: {
          "type": "default",
          "round": ""
        },
        on: {
          "click": function($event) {
            return _vm.download(row.name + '-' + row.grade, row.pdf_url)
          }
        }
      }, [_vm._v("点击下载\n                ")])], 1)])]) : _vm._e()])
    }), 1) : _c('div', {
      staticStyle: {
        "text-align": "center",
        "padding": "0.2rem",
        "margin": "0 0.2rem",
        "background": "#fff",
        "border-radius": ".2rem"
      }
    }, [_vm._v("系统中暂无记录")])], 1)
  }), _vm._v(" "), (_vm.emptyShow) ? _c('div', {}, [_c('van-empty', {
    staticStyle: {
      "margin": "10px auto"
    },
    attrs: {
      "description": "暂无结果"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'CertPersonPhoto'
      }),
      expression: "{name: 'CertPersonPhoto'}"
    }],
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    }
  }, [_vm._v("上传证件照")])], 1)], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0767bd74","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/yeyudengji/YeyudengjiCertDetail.vue
// module id = 2191
// module chunks = 0